// removed by extract-text-webpack-plugin
module.exports = {"card":"_73NG"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/EmptyMessage/EmptyMessage.scss
// module id = gOs4
// module chunks = 0